/* Heitz cart drawer (11a) — fast + smooth. v5.2 (variant change fixed)
   · Quantity / remove / variant / protection / discount
   · One request per change: /cart/change.js also returns the re-rendered drawer (sections API)
   · Optimistic +/- (number changes instantly, rapid taps are merged into one request)
   · Rows slide out on remove, new items slide in after "Add to cart"
   · Tells the header + theme about new counts with the "cart:update" event */
(function () {
  if (window.__hzcdReady) return;
  window.__hzcdReady = true;

  var root = function () { return document.querySelector('[data-hzcd]'); };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  var timers = {};
  var want = {};      /* qty the shopper asked for, per line key, until the server agrees */
  var inflight = 0;   /* cart calls queued or running */
  function busy() { if (inflight > 0) return true; for (var k in timers) if (timers[k]) return true; return false; }
  /* after a patch, put back any qty the shopper changed that the server has not caught up with yet */
  function reapply() {
    var el = root(); if (!el) return;
    [].forEach.call(el.querySelectorAll('.hzcd__item'), function (r) {
      var k = r.dataset.key; if (want[k] == null) return;
      if (+r.dataset.qty === want[k] && !busy()) { delete want[k]; return; }
      r.dataset.qty = want[k];
      var q = r.querySelector('[data-hzcd-q]'); if (q) q.textContent = want[k];
    });
  }

  function sid() { var el = root(); return el ? el.getAttribute('data-section-id') : ''; }

  function post(url, body, withSection) {
    if (withSection && sid()) { body.sections = [sid()]; body.sections_url = window.location.pathname; }
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }

  function announce(cart) {
    try {
      /* the theme's drawer re-opens itself on every cart:update when "auto-open" is on —
         our own +/− / remove updates must never re-open it, so switch that off for this event */
      if (!window.__hzcdAllowUntil || Date.now() > window.__hzcdAllowUntil) window.__hzcdBlockUntil = Date.now() + 1500;
      var cdc = [].slice.call(document.querySelectorAll('cart-drawer-component[auto-open], [data-auto-open]'));
      cdc.forEach(function (c) { c.__hzAuto = true; c.removeAttribute('auto-open'); });
      /* our own +/− / remove changes use a private event, so the theme never re-opens the drawer */
      var ev = new Event('hzcd:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'hzcd', data: { itemCount: cart.item_count, source: 'hzcd' } };
      document.dispatchEvent(ev);
      setTimeout(function () { cdc.forEach(function (c) { if (c.__hzAuto) { c.setAttribute('auto-open', ''); c.__hzAuto = false; } }); }, 400);
    } catch (e) {}
  }

  /* speed up "Add to cart" from product page / quick add: ask Shopify to render
     this drawer in the same /cart/add response, so it fills instantly */
  (function () {
    var of = window.fetch; if (!of || of.__hzcd) return;
    var wrapped = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var id = sid();
        if (id && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
          var el = root(); if (el) { el.classList.add('is-loading'); el.__hzAdding = Date.now(); }
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            var cur = init.body.get('sections');
            var list = cur ? String(cur).split(',') : [];
            if (list.indexOf(id) < 0) { list.push(id); init.body.set('sections', list.join(',')); }
            if (!init.body.get('sections_url')) init.body.set('sections_url', window.location.pathname);
          } else if (typeof init.body === 'string' && init.body.charAt(0) === '{') {
            var b = JSON.parse(init.body);
            var s = b.sections ? (Array.isArray(b.sections) ? b.sections : String(b.sections).split(',')) : [];
            if (s.indexOf(id) < 0) s.push(id);
            b.sections = s; if (!b.sections_url) b.sections_url = window.location.pathname;
            init.body = JSON.stringify(b);
          }
          return of.call(this, input, init).then(function (res) {
            res.clone().json().then(function (data) {
              if (data && data.sections && data.sections[id]) patch(data.sections[id], true);
            }).catch(function () {});
            return res;
          });
        }
      } catch (e) {}
      return of.apply(this, arguments);
    };
    wrapped.__hzcd = true;
    window.fetch = wrapped;
  })();

  function keysNow() { var el = root(); return el ? [].map.call(el.querySelectorAll('.hzcd__item'), function (r) { return r.dataset.key + '|' + r.dataset.qty; }) : []; }

  /* swap the drawer content from a rendered section string */
  function patch(html, animateNew) {
    if (!html) return;
    var cur = root(); if (!cur) return;
    var bare = html.replace(/<template[\s\S]*?<\/template>/g, '');
    if (cur.__hzEmpty) {
      var hasItems = bare.indexOf('hzcd__item') > -1;
      var realAdd = cur.__hzAdding && cur.__hzAdding > (cur.__hzEmptyAt || 0);
      /* after the last item is removed, ignore late/stale renders that still show items — only a real add brings them back */
      if (!hasItems || !realAdd) { cur.classList.remove('is-loading'); cur.__hzPatchedAt = Date.now(); return; }
    }
    cur.__hzEmpty = false;
    var before = keysNow();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-hzcd]');
    if (!fresh) return;
    var sc = cur.querySelector('[data-hzcd-scroll]'), top = sc ? sc.scrollTop : 0;
    var discOpen = !!cur.querySelector('.hzcd__disc.is-open');
    var oldBody = cur.querySelector('[data-hzcd-scroll]'), newBody = fresh.querySelector('[data-hzcd-scroll]');
    if (oldBody && newBody && oldBody.querySelector('.hzcd__item') && newBody.querySelector('.hzcd__item')) {
      /* keep the existing rows (and their loaded images) — only swap what changed */
      var oldRows = {};
      [].forEach.call(oldBody.querySelectorAll('.hzcd__item'), function (r) { oldRows[r.dataset.key] = r; });
      [].forEach.call(newBody.querySelectorAll('.hzcd__item'), function (nr) {
        var or = oldRows[nr.dataset.key];
        if (!or) return;
        var oi = or.querySelector('.hzcd__img img'), ni = nr.querySelector('.hzcd__img img');
        if (oi && ni && oi.getAttribute('src') && ni.getAttribute('src') && oi.currentSrc) ni.replaceWith(oi);
      });
      oldBody.innerHTML = newBody.innerHTML;
      [].forEach.call(cur.children, function (ch) {
        if (ch === oldBody || ch.contains(oldBody)) return;
        var sel = ch.className ? '.' + String(ch.className).trim().split(/\s+/)[0] : null;
        var nf = sel ? fresh.querySelector(':scope > ' + sel) : null;
        if (nf && nf.innerHTML !== ch.innerHTML) ch.innerHTML = nf.innerHTML;
      });
    } else {
      cur.innerHTML = fresh.innerHTML;
    }
    ['data-prot-id', 'data-prot-key'].forEach(function (a) { if (fresh.hasAttribute(a)) cur.setAttribute(a, fresh.getAttribute(a)); else cur.removeAttribute(a); });
    var sc2 = cur.querySelector('[data-hzcd-scroll]'); if (sc2) sc2.scrollTop = animateNew ? 0 : top;
    if (discOpen) { var d = cur.querySelector('.hzcd__disc'); if (d) d.classList.add('is-open'); }
    if (animateNew) {
      [].forEach.call(cur.querySelectorAll('.hzcd__item'), function (r) {
        if (before.indexOf(r.dataset.key + '|' + r.dataset.qty) < 0) r.classList.add('is-new');
      });
    }
    cur.classList.remove('is-loading'); cur.__hzPatchedAt = Date.now();
    if (animateNew) { cur.classList.add('is-fresh'); setTimeout(function () { cur.classList.remove('is-fresh'); }, 400); }
    var dlg = cur.closest('dialog');
    if (dlg) dlg.classList.toggle('cart-drawer--empty', !cur.querySelector('.hzcd__item'));
  }

  function refresh(animateNew) {
    var id = sid(); if (!id) return Promise.resolve();
    var el = root(); if (el && animateNew) el.classList.add('is-loading');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) { patch(data[id], animateNew); });
  }

  /* run one cart call at a time, patch from its own response when possible */
  function run(fn, row) {
    inflight++;
    queue = queue.then(function () {
      if (row && document.contains(row)) row.classList.add('is-busy');
      return fn().then(function (res) {
        inflight--;
        /* more taps are waiting → skip this (now old) render, the last call will draw the drawer */
        if (busy()) return;
        var cart = res && res.items && res.item_count != null ? res : null;
        if (cart) announce(cart);
        if (res && res.sections && res.sections[sid()]) { patch(res.sections[sid()]); reapply(); }
        else return refresh().then(reapply);
      }).catch(function (err) {
        inflight--;
        if (busy()) return;
        var r = row && document.contains(row) ? row : null;
        if (r) {
          r.classList.remove('is-busy', 'is-leaving');
          var m = r.querySelector('[data-hzcd-err]');
          if (m) { m.hidden = false; m.textContent = (err && (err.description || err.message)) || 'Could not update the cart.'; }
        }
        return refresh();
      });
    });
    return queue;
  }

  function change(key, qty) { return function () { return post('cart/change.js', { id: key, quantity: qty }, true); }; }

  function setQty(row, qty) {
    var key = row.dataset.key;
    row.dataset.qty = qty;
    want[key] = qty;
    var q = row.querySelector('[data-hzcd-q]');
    if (q) { q.textContent = qty; q.classList.remove('is-tick'); void q.offsetWidth; q.classList.add('is-tick'); }
    clearTimeout(timers[key]); timers[key] = 0;
    if (qty <= 0) { delete want[key]; leave(row); return; }
    timers[key] = setTimeout(function () {
      timers[key] = 0;
      var r = root() && root().querySelector('.hzcd__item[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      run(change(key, want[key] != null ? want[key] : qty), r || row);
    }, 320);
  }
  /* read the qty the shopper sees (not a stale server value) */
  function curQty(row) { var k = row.dataset.key; return want[k] != null ? want[k] : +row.dataset.qty; }

  /* last product removed → show the empty state right away (no waiting for the server) */
  function zeroCount() {
    try { var ev = new Event('hzcd:update', { bubbles: true }); ev.detail = { resource: { items: [], item_count: 0 }, sourceId: 'hzcd', data: { itemCount: 0, source: 'hzcd' } }; document.dispatchEvent(ev); } catch (e) {}
    [].forEach.call(document.querySelectorAll('[data-hzh-count]'), function (c) { c.textContent = '0'; c.hidden = true; });
  }
  function goEmpty() {
    zeroCount();
    /* once the server has removed everything, sync the real count */
    setTimeout(function () { queue.then(function () { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); }).then(function (c) { if (c && c.items) announce(c); }).catch(function () {}); }, 50);
    var el = root(); if (!el || el.__hzEmpty || el.querySelector('.hzcd__empty')) return;
    var tpl = el.querySelector('[data-hzcd-empty-tpl]'); if (!tpl) return;
    el.__hzEmpty = true; el.__hzEmptyAt = Date.now();
    el.classList.add('is-emptying');
    var ttl = el.querySelector('.hzcd__title'); if (ttl) ttl.textContent = '';
    setTimeout(function () {
      var cur = root(); if (!cur) return;
      [].forEach.call(cur.querySelectorAll('.hzcd__ship-wrap, .hzcd__body, .hzcd__foot, .hzcd__empty'), function (n) { n.remove(); });
      var box = document.createElement('div');
      box.innerHTML = tpl.innerHTML;
      tpl.insertAdjacentElement('afterend', box.firstElementChild);
      cur.classList.remove('is-emptying');
      var dlg = cur.closest('dialog'); if (dlg) dlg.classList.add('cart-drawer--empty');
    }, 180);
  }

  /* theme may swap the drawer markup on its own — keep the empty state if we are emptying */
  ['cart:update', 'hzcd:update'].forEach(function (evn) { document.addEventListener(evn, function () {
    setTimeout(function () {
      var el = root(); if (!el) return;
      var items = el.querySelectorAll('.hzcd__item').length;
      if (!items && !el.querySelector('.hzcd__empty') && el.querySelector('[data-hzcd-empty-tpl]')) { el.__hzEmpty = false; goEmpty(); }
    }, 30);
  }); });

  function leave(row) {
    var el = root();
    var others = el ? [].filter.call(el.querySelectorAll('.hzcd__item'), function (r) { return r !== row && !r.classList.contains('is-leaving'); }) : [];
    if (!others.length && !(el && el.__hzEmpty)) goEmpty();
    row.style.height = row.offsetHeight + 'px';
    void row.offsetHeight;
    row.classList.add('is-leaving');
    row.style.height = '0px';
    run(change(row.dataset.key, 0), row);
  }

  document.addEventListener('click', function (e) {
    var el = root();
    if (!el || !el.contains(e.target)) return;
    var t = e.target;
    var row = t.closest('.hzcd__item');

    if (row && (t.closest('[data-hzcd-rm]') || (t.closest('[data-hzcd-dec]') && curQty(row) <= 1))) {
      var rest = [].filter.call(el.querySelectorAll('.hzcd__item'), function (r) { return r !== row && !r.classList.contains('is-leaving'); });
      if (!rest.length) goEmpty();
    }
    if (t.closest('[data-hzcd-inc]') && row) setQty(row, curQty(row) + 1);
    else if (t.closest('[data-hzcd-dec]') && row) setQty(row, Math.max(0, curQty(row) - 1));
    else if (t.closest('[data-hzcd-rm]') && row) { clearTimeout(timers[row.dataset.key]); timers[row.dataset.key] = 0; delete want[row.dataset.key]; leave(row); }
    else if (t.closest('[data-hzcd-prot]')) {
      var id = el.getAttribute('data-prot-id');
      if (!id) return;
      var b = t.closest('[data-hzcd-prot]'), sw = b.querySelector('.hzcd__sw');
      /* flip the switch instantly, send one request after taps settle */
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', String(on));
      if (sw) sw.classList.toggle('is-on', on);
      clearTimeout(timers.__prot);
      timers.__prot = setTimeout(function () {
        timers.__prot = 0;
        var u = {}; u[id] = b.getAttribute('aria-pressed') === 'true' ? 1 : 0;
        run(function () { return post('cart/update.js', { updates: u }, true); });
      }, 220);
    } else if (t.closest('[data-hzcd-disc-toggle]')) {
      var d = t.closest('.hzcd__disc');
      d.classList.toggle('is-open');
      t.closest('[data-hzcd-disc-toggle]').setAttribute('aria-expanded', String(d.classList.contains('is-open')));
      if (d.classList.contains('is-open')) setTimeout(function () { var i = d.querySelector('input'); if (i) i.focus(); }, 250);
    } else if (t.closest('[data-hzcd-code-rm]')) {
      try { document.cookie = 'discount_code=; path=/; max-age=0'; } catch (e) {}
      run(function () { return post('cart/update.js', { discount: '' }, true); });
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hzcd-variant]');
    if (!sel) return;
    var row = sel.closest('.hzcd__item');
    var qty = +row.dataset.qty, oldKey = row.dataset.key, newId = +sel.value;
    if (newId === +row.dataset.variant) return;
    /* one request: old line to 0 and new variant in, so the drawer never shows both rows */
    var el = root(), upd = {}, twin = null;
    [].forEach.call(el.querySelectorAll('.hzcd__item'), function (r) { if (r !== row && +r.dataset.variant === newId) twin = r; });
    upd[oldKey] = 0;
    if (twin) upd[twin.dataset.key] = (+twin.dataset.qty || 0) + qty; /* same variant already in cart: merge */
    else upd[newId] = qty;
    clearTimeout(timers[oldKey]); timers[oldKey] = 0; delete want[oldKey];
    row.classList.add('is-busy');
    run(function () { return post('cart/update.js', { updates: upd }, true); }, row);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-hzcd-disc-form]');
    if (!f) return;
    e.preventDefault();
    var code = (f.code.value || '').trim();
    var msg = f.parentNode.querySelector('[data-hzcd-disc-msg]');
    if (!code) { if (msg) { msg.style.color = '#B3261E'; msg.textContent = 'Enter a code'; } return; }
    var prev = [];
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      prev = (c.discount_codes || []).map(function (d) { return d.code; });
      return post('cart/update.js', { discount: prev.concat([code]).join(',') }, true);
    }).then(function (cart) {
      var ok = (cart.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code.toUpperCase() && d.applicable; });
      if (!ok) {
        if (msg) { msg.style.color = '#B3261E'; msg.textContent = 'That code isn\u2019t valid for this cart.'; }
        return post('cart/update.js', { discount: prev.join(',') });
      }
      announce(cart);
      patch(cart.sections && cart.sections[sid()]);
    }).catch(function () { if (msg) { msg.style.color = '#B3261E'; msg.textContent = 'Could not apply the code.'; } });
  });

  /* if the theme ever opens the drawer non-modally, re-open it as a proper modal overlay */
  /* never let the drawer pop open again right after the customer closed it,
     unless a product was really added (count went up) */
  window.__hzcdLastClose = 0; window.__hzcdAllowUntil = 0;
  function fixModal() {
    var el = root(); var dlg = el && el.closest('dialog');
    if (!dlg || dlg.__hzcdObs) return;
    dlg.addEventListener('close', function () {
      window.__hzcdLastClose = Date.now();
      /* after the last change has finished, sync the real count to the header (no re-open) */
      queue.then(function () { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); }).then(function (c) { if (c && c.item_count != null) { window.__hzcdCount = c.item_count; announce(c); } }).catch(function () {});
    });
    dlg.__hzcdObs = new MutationObserver(function () {
      try {
        if (dlg.open) {
          var now = Date.now();
          /* the drawer may only open from: the cart icon, an add to cart, or the theme editor */
          if (now > window.__hzcdAllowUntil && !(window.Shopify && window.Shopify.designMode)) { dlg.close(); return; }
          if (!dlg.matches(':modal')) { dlg.close(); dlg.showModal(); }
        }
      } catch (e) {}
    });
    dlg.__hzcdObs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixModal); else fixModal();
  /* only a real "add to cart" request may open the drawer by itself */
  (function () {
    var of = window.fetch; if (!of || of.__hzcdWrap) return;
    var wf = function (input) { try { var u = typeof input === 'string' ? input : (input && input.url) || ''; if (/\/cart\/add/.test(u)) window.__hzcdAllowUntil = Date.now() + 6000; } catch (e) {} return of.apply(this, arguments); };
    wf.__hzcdWrap = true; window.fetch = wf;
  })();
  /* the theme can re-render the whole drawer (new <dialog>) — guard every new one too */
  var fmT = 0;
  new MutationObserver(function () { clearTimeout(fmT); fmT = setTimeout(fixModal, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.action && /\/cart\/add/.test(f.action)) window.__hzcdAllowUntil = Date.now() + 6000; }, true);
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[name="add"], .add-to-cart-button, [data-hpdp-sticky-atc], [data-qa-add], [data-add], [data-hzcd-up]'); if (b) window.__hzcdAllowUntil = Date.now() + 6000; }, true);
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('cart-icon, [data-hzh-cart], a[href="/cart"], .hzh-cart'); if (b) window.__hzcdAllowUntil = Date.now() + 2000; }, true);

  /* product added elsewhere (product page, quick add, wishlist) → refresh with a slide-in for the new item */
  document.addEventListener('cart:update', function (e) {
    var dt = e && e.detail;
    var src = dt && (dt.sourceId || (dt.data && dt.data.source));
    var n = dt && ((dt.resource && dt.resource.item_count) != null ? dt.resource.item_count : (dt.data && dt.data.itemCount));
    if (n != null) window.__hzcdCount = n;
    if (src === 'hzcd') return;
    var html = dt && dt.data && dt.data.sections && dt.data.sections[sid()];
    if (html) { patch(html, true); return; }
    var el = root();
    if (el && el.__hzPatchedAt && Date.now() - el.__hzPatchedAt < 1500) return;
    refresh(true);
  });
})();
